module.exports = __webpack_public_path__ + "static/assets/a3e613b3b210291eba8ac6fa067d3eba.png";